export default __webpack_public_path__ + "93a5839419708e0fe156c1c9a5231a80.png";